import type { Components, Theme } from '@mui/material';
import { pxToRem } from '../../../utils';

const LG_CONTENT_WIDTH = 1440;
const LG_GUTTER = 80;

export const containerConfig: Components<Omit<Theme, 'components'>> = {
  MuiContainer: {
    styleOverrides: {
      root: ({ theme }) => ({
        paddingRight: pxToRem(24),
        paddingLeft: pxToRem(24),

        [theme.breakpoints.up('sm')]: {
          paddingRight: pxToRem(40),
          paddingLeft: pxToRem(40),
        },
        [theme.breakpoints.up('md')]: {
          paddingRight: pxToRem(64),
          paddingLeft: pxToRem(64),
        },
        [theme.breakpoints.up('lg')]: {
          paddingRight: pxToRem(LG_GUTTER),
          paddingLeft: pxToRem(LG_GUTTER),

          /**
           * Our `lg` breakpoint is 1440px and we want the *content area* (not the
           * outer box) to be 1440px wide on large viewports, with a minimum 80px
           * gutter on each side.
           *
           * MUI's Container uses `box-sizing: border-box`, so `max-width` caps the
           * outer box — padding eats into it. With the default `maxWidth="lg"` of
           * 1440px and 80px side padding, content ends up 1440 - 160 = 1280px.
           *
           * We can't fix this with margin (Container relies on `margin: 0 auto`
           * for centering) and `box-sizing: content-box` breaks because MUI also
           * sets `width: 100%`, which causes the container to overflow its parent
           * when the parent is narrower than content + padding.
           *
           * Solution: bump maxWidth to content + 2×gutter so the outer box is
           * sized to accommodate the padding. Result on `lg`:
           *   - viewport ≥ 1600px: content is exactly 1440px, 80px gutter each
           *     side, auto-margins distribute the remaining space.
           *   - viewport < 1600px: container fills the parent, gutter stays 80px,
           *     content shrinks.
           */
          maxWidth: pxToRem(LG_CONTENT_WIDTH + LG_GUTTER * 2),
        },
      }),
    },
  },
};
